/* unplugin-vue-components disabled */import script from "./NowOverdue.vue?vue&type=script&setup=true&lang=js"
export * from "./NowOverdue.vue?vue&type=script&setup=true&lang=js"

import "./NowOverdue.vue?vue&type=style&index=0&id=02108b96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02108b96"]])

export default __exports__